/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Purchase_Date_ToInputs */

const vi_tea_purchase_date_to = /** @type {(inputs: Tea_Purchase_Date_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngày cân (đến)`)
};

/**

* @param {Tea_Purchase_Date_ToInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_purchase_date_to = /** @type {((inputs?: Tea_Purchase_Date_ToInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Purchase_Date_ToInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_purchase_date_to(inputs)
});